import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Ensures that the end date is not earlier than the start date.
 *
 * - Compares two controls within a FormGroup
 * - Adds/removes `endBeforeStart` error on the end control
 *
 * @param startKey FormControl name for the start date
 * @param endKey FormControl name for the end date
 */
export function endDateAfterStartDateValidator(startKey: string, endKey: string): ValidatorFn {
	return (group: AbstractControl): ValidationErrors | null => {
		const startCtrl = group.get(startKey);
		const endCtrl = group.get(endKey);

		if (!startCtrl || !endCtrl) {
			return null;
		}

		const startTime = toDateTime(startCtrl.value);
		const endTime = toDateTime(endCtrl.value);

		const currentErrors = endCtrl.errors ?? {};

		if (!startTime || !endTime) {
			if (currentErrors['endBeforeStart']) {
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				const { endBeforeStart, ...rest } = currentErrors;
				endCtrl.setErrors(Object.keys(rest).length ? rest : null);
			}
			return null;
		}

		if (endTime < startTime) {
			endCtrl.setErrors({
				...currentErrors,
				endBeforeStart: true,
			});
		} else if (currentErrors['endBeforeStart']) {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { endBeforeStart, ...rest } = currentErrors;
			endCtrl.setErrors(Object.keys(rest).length ? rest : null);
		}

		return null;
	};
}

function toDateTime(value: unknown): number | null {
	if (!value) {
		return null;
	}

	if (value instanceof Date) {
		return value.getTime();
	}

	if (typeof value === 'string') {
		const time = new Date(value).getTime();
		return Number.isNaN(time) ? null : time;
	}

	return null;
}
